<agr-page-toolbar
  [pageTitle]="'delivery.overview-title' | translate"
  data-test="deliveries-overview"
>
  <ng-container actions>
    <div
      class="flex--column spacing--padding-right padding-top-5"
      *ngIf="locationChipItems$ | async as locationChipItems"
    >
      <agr-chips-filter
        [multiple]="true"
        [items]="locationChipItems"
        (change)="changeLocation($event)"
        data-test="chip-locations"
      ></agr-chips-filter>
    </div>
  </ng-container>

  <app-page-table-filter
    [pageTitle]="'delivery.overview-title' | translate"
    [searchFieldPlaceholder]="'delivery.search-placeholder' | translate"
    [emptyTitle]="'delivery.empty-title' | translate"
    [emptyDescription]="'delivery.empty-description' | translate"
    [tableConfig]="tableConfig"
    [showTotals]="false"
    [showFilters]="false"
    [data$]="deliveryLines$"
    (loadDataCallback)="loadData()"
  >
  </app-page-table-filter>

  <ng-template #isActiveColumn let-row="row">
    <mat-slide-toggle
      data-test="delivery-overview_toggle-active"
      color="primary"
      [hideIcon]="true"
      [checked]="row.isActive"
      (change)="onToggleActive(row)"
    >
    </mat-slide-toggle>
  </ng-template>
</agr-page-toolbar>
